import instance from "../auth/axios";

// Get all units for the authenticated user (optionally filtered by site_id)
const getUserUnits = (siteId = null) => {
  const url = siteId ? `/units?site_id=${siteId}` : '/units';
  return instance.get(url).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching user units:', error);
    throw error;
  });
};

// Get units for a specific site
const getSiteUnits = (siteId) => {
  return instance.get(`/units/site/${siteId}`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching site units:', error);
    throw error;
  });
};

// Get a specific unit by ID
const getUnitById = (unitId) => {
  return instance.get(`/units/${unitId}`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error fetching unit:', error);
    throw error;
  });
};

// Create a new unit
const createUnit = (unitData) => {
  return instance.post('/units', unitData).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error creating unit:', error);
    throw error;
  });
};

// Update a unit
const updateUnit = (unitId, unitData) => {
  return instance.put(`/units/${unitId}`, unitData).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error updating unit:', error);
    throw error;
  });
};

// Delete a unit
const deleteUnit = (unitId) => {
  return instance.delete(`/units/${unitId}`).then((response) => {
    if (response) {
      return response.data;
    }
  }).catch((error) => {
    console.error('Error deleting unit:', error);
    throw error;
  });
};

export {
  getUserUnits,
  getSiteUnits,
  getUnitById,
  createUnit,
  updateUnit,
  deleteUnit
};
